import React from 'react';
import {t} from 'ttag';
import {GridRenderCellParams, GridRowParams} from '@mui/x-data-grid';
import {Button} from '@mui/material';
import {KeyboardDoubleArrowRight} from '@mui/icons-material';
import {IInvoiceDetails} from '../../../../store/apis/interfaces/invoice';

export const columns = (onSelect: (ticketId: string) => void) => {
  return [
    {
      field: 'ticket',
      headerName: t`Ticket`,
      flex: 1,
      minWidth: 150,
      sortable: false,
      cellClassName: 'bold'
    },
    {
      field: 'paxMame',
      headerName: t`Passenger Name`,
      flex: 1,
      minWidth: 200,
      sortable: false,
      valueGetter: (params: GridRowParams) => {
        const paxMame = params.row?.details?.Paxname || '';
        let [lastName, firstName] = paxMame.toLowerCase().split(/[/\\]/);
        firstName = firstName?.replace(/(mr|mrs)$/i, '').trim();
        return `${firstName?.[0]?.toUpperCase() + firstName?.slice(1)}
        ${lastName?.split(' ').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}`;
      }
    },
    {
      field: 'taxId',
      headerName: t`Tax ID`,
      flex: 1,
      minWidth: 150,
      sortable: false,
      cellClassName: 'secondary-text',
      valueGetter: (params: GridRowParams) => {
        return params?.row?.taxId || 'N/A';
      }
    },
    {
      field: 'amount',
      headerName: t`Amount`,
      flex: 1,
      minWidth: 150,
      sortable: false,
      valueGetter: (params: GridRowParams) => {
        const {Payment, Currency} = params.row?.details as IInvoiceDetails;
        return `${Payment?.reduce((sum, item) => sum + (Number(item?.Amount) || 0), 0)} ${Currency}`;
      }
    },
    {
      field: 'action',
      headerName: '',
      minWidth: 105,
      maxWidth: 105,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({row}: GridRenderCellParams) => {
        return (
          <Button
            fullWidth={true}
            variant={'contained'}
            size={'small'}
            onClick={() => onSelect(row?.ticket)}
            startIcon={<KeyboardDoubleArrowRight />}
          >
            {t`Select`}
          </Button>
        );
      }
    }
  ];
};
